// extracted by mini-css-extract-plugin
module.exports = {"container":"static-chat-input_container__6I9CW","input":"static-chat-input_input__8KpyW","submit":"static-chat-input_submit__lrVlZ"};